'use client';

import { ImageLoaderProps } from 'next/image';

const CACHE_BUST = '12-11-2025';

const PRESET_WIDTHS = [
  575,
  640,
  750,
  828,
  1080,
  1200,
  1920,
  2048,
  3840,
];

const imageLoader = ({
  src,
  width,
  quality = 75,
}: ImageLoaderProps) => {
  if (!src) return src;

  const directusApiUri =
    `${process.env.NEXT_PUBLIC_DIRECTUS_NC_API_URL}/assets`;

  const url = new URL(src);
  const urlParams = url.searchParams;

  const desktopImage = urlParams.get('__dis');
  const mobileImage = urlParams.get('__mis');

  const isMobile = width <= 575;

  const imageToDisplay = isMobile
    ? (mobileImage || desktopImage)
    : (desktopImage || mobileImage);

  if (!imageToDisplay) {
    return src;
  }

  const requestedWidth =
    PRESET_WIDTHS.find((w) => w >= width) ??
    PRESET_WIDTHS[PRESET_WIDTHS.length - 1];

  return `${directusApiUri}/${imageToDisplay}?key=image-q${quality}-w${requestedWidth}&_requested_width=${requestedWidth}&v=${CACHE_BUST}`;
}

export default imageLoader;